import { render, staticRenderFns } from "./Pratica.vue?vue&type=template&id=5ab9b4ce&scoped=true&"
import script from "./Pratica.vue?vue&type=script&lang=js&"
export * from "./Pratica.vue?vue&type=script&lang=js&"
import style0 from "./Pratica.vue?vue&type=style&index=0&id=5ab9b4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9b4ce",
  null
  
)

export default component.exports